import { adoptedStyleSheetsSupport } from "@otto-ec/otto-components-utils/utils/canIUse";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useShadowStylesInjector(styles?: () => Promise<typeof import("*?inline")>) {
  const adoptedRoots = new WeakSet<ShadowRoot>();
  let styleSheet: CSSStyleSheet | undefined;

  /**
 *
 *
 *
 *
 */
  return async function addStylesToParentShadowRootsIfNeeded(element: HTMLElement): Promise<void> {
    if (!styles) return;

    const rootNode = element.getRootNode();
    if (rootNode instanceof ShadowRoot && !adoptedRoots.has(rootNode)) {
      const css = await styles();
      if (adoptedStyleSheetsSupport) {
        if (!styleSheet) {
          styleSheet = new CSSStyleSheet();
          /*                                                                           */
          styleSheet.replace(css.default);
        }
        rootNode.adoptedStyleSheets.push(styleSheet);
      } else {
        const styleEl = document.createElement("style");
        styleEl.textContent = css.default;
        rootNode.appendChild(styleEl);
      }

      adoptedRoots.add(rootNode);
    }
  };
}
